module.exports = __webpack_public_path__ + "img/secretheart@2x.e6321bf.webp";